import { render, staticRenderFns } from "./PropertyCustomerEmpty.vue?vue&type=template&id=7412c01d&scoped=true&lang=pug&"
import script from "./PropertyCustomerEmpty.vue?vue&type=script&lang=js&"
export * from "./PropertyCustomerEmpty.vue?vue&type=script&lang=js&"
import style0 from "./PropertyCustomerEmpty.vue?vue&type=style&index=0&id=7412c01d&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7412c01d",
  null
  
)

export default component.exports